import find from 'lodash/find'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import values from 'lodash/values'
import words from 'lodash/words'

import {
  CROWN_BUTTON_WITH_COLOR,
  STUMP_SHADE_BUTTON_WITH_COLOR,
} from './constants'

export const getInitials = (name: string) =>
  words(name)
    .map((word) => upperFirst(word.charAt(0)))
    .join('')

export const findBackgroundByCrownKey = (key = '') => {
  return (
    find(values(CROWN_BUTTON_WITH_COLOR), (category) => has(category, key))?.[
      key
    ] || null
  )
}

export const findBackgroundByStumpShadeKey = (key = '') => {
  return (
    find(values(STUMP_SHADE_BUTTON_WITH_COLOR), (category) =>
      has(category, key),
    )?.[key] || null
  )
}
